module.exports = "---\ntitle: \"文章预告\"\ntime: \"2026-3-23\"\n---\n\n最近在写一个自定义指令集和VM，正在打算为它写点东西。\n";